import StyledLink from '../StyledLink'
import {
  ADD,
  SYSTEM,
  WEBHOOK
} from '@eggplant/routing'
import type { Props } from '../types'

const LinkToAddWebhook = ({
  children,
  isHyperlink
}: Props) =>
  <StyledLink
    isHyperlink={isHyperlink}
    to={`/${SYSTEM}/${WEBHOOK}/${ADD}`}
  >
    {children}
  </StyledLink>

export default LinkToAddWebhook
